import Vue from 'vue'

const state = {
  card: null,
  companyDetails: null,
  modalOpened: false
}

const getters = {
  cardOpened: (state) => state.card,
  cardTitle: (state) => state.card == null ? '' : state.card.title,
  cardId: (state) => {
    return state.card ? state.card.id : 0
  },
  shadow: (state) => {
    if (state.card) {
      if (state.card.shadow && (state.card.type === 'fromotherboard')) {
        return 'detached'
      }
      if (state.card.shadow && (state.card.type === 'trigger')) {
        return 'trigger'
      }
    }
    return ''
  },
  companyDetails: (state) => state.companyDetails,
  isModalCardOpened: (state) => state.modalOpened,
  cardUsers: (state) => state.card.users
}

const actions = {
  setCardModalOpened ({ commit }, status) {
    commit('SET_MODAL_OPENED', status)
  },

  // Informa que um cartão foi aberto
  showCard ({ commit }, card) {
    commit('CREATE_OPENED_CARD', card)
  },

  // Adiciona a informação detalhadas sobre a empresa
  addCompanyDetails ({ commit }, companyDetails) {
    commit('ADD_COMPANY_DETAILS', companyDetails)
  },

  updateTitle ({ commit }, title) {
    commit('ADD_TITLE', title)
  },

  // Adiciona uma nova tag ao cartão, refletindo também na tag do item
  addTags ({ commit }, tags) {
    commit('ADD_TAGS', tags)
  },

  // Atualiza as tags do cartão, refletindo também na tag do item e quando
  // necessário de todos os cartões
  updateTags ({ dispatch, commit }, mode) {
    commit('UPDATE_TAGS', mode)
    if (mode.action === 'update' || mode.action === 'deleteAll') {
      dispatch('board/updateTags', mode, { root: true })
    }
  },

  // Adiciona um novo usuário ao cartão, refletindo também no usuário do item
  addUsers ({ commit }, users) {
    commit('ADD_USERS', users)
  },

  // Atualiza os usuários do cartão, refletindo também no usuário do item
  updateUsers ({ commit }, users) {
    commit('UPDATE_USERS', users)
  },

  // Atualiza os total de itens selecionado no cartão item
  addTotalsChecks ({ commit }, totals) {
    commit('ADD_TOTALITEMS', totals.totalItems)
    commit('CHECKED_CHECKITEM', totals.checkedItems)
  },

  // Atualiza o item selecionado no cartão item
  checkItemInTheCard ({ commit }, check) {
    if (check) {
      commit('ADD_CHECKITEM')
    } else {
      commit('REMOVE_CHECKITEM')
    }
  },

  checkAllInTheCard ({ commit }, { checkLists, checked }) {
    commit('ALL_CHECKITEM', { checkLists, checked })
  },

  updateChecked ({ commit }, { checkLists, checked }) {
    commit('UPDATE_All_CHECKED', { checkLists, checked })
  },

  updateCheckedAproved ({ commit }, { checkList }) {
    commit('UPDATE_All_CHECKED_APROVED', { checkList })
  },

  changeStatus ({ commit }, status) {
    commit('CHANGE_STATUS', status)
  },

  // Informa que o cartão foi fechado
  closeCard ({ commit }) {
    commit('DESTROY_OPENED_CARD')
  },

  updateHistoryByCheckedAction ({ commit, dispatch, getters }, checkedAction) {
    let currUser = getters.cardUsers.find(find => find.id === checkedAction.user.id)
    let newCardUser = !currUser ? checkedAction.user : null

    dispatch('history/addHistories', checkedAction.histories, { root: true })

    if (newCardUser !== null) {
      commit('UPDATE_USERS', { user: newCardUser, action: 'add' })
    }
  },

  // Atualiza estado do vencimento no item
  updateCardDueDate ({ commit, dispatch }, { dueState, dueDate, newDate }) {
    commit('UPDATE_DUE_STATE', { dueState, dueDate, newDate })

    if (dueDate || newDate) {
      if (!dueDate && newDate) {
        dispatch('history/addDueDateDesc', { dueDate, newDate, action: 'add' }, { root: true })
      } else if (!newDate && dueDate) {
        dispatch('history/addDueDateDesc', { dueDate, newDate, action: 'remove' }, { root: true })
      } else if (newDate !== dueDate) {
        dispatch('history/addDueDateDesc', { dueDate, newDate, action: 'update' }, { root: true })
      }
    }
  },

  removeCardFromList ({ commit, rootGetters }, card) {
    var lists = rootGetters['board/lists']
    commit('REMOVE_CARD_FROM_LISTS', { card, lists })
  }
}

const mutations = {
  SET_MODAL_OPENED (state, status) {
    state.modalOpened = status
  },

  CREATE_OPENED_CARD (state, card) {
    state.card = card
  },

  ADD_TOTALITEMS (state, totalItems) {
    if (state.card) {
      state.card.totalItems = totalItems
    }
  },

  CHECKED_CHECKITEM (state, checkedItems) {
    if (state.card) {
      state.card.checkedItems = checkedItems
    }
  },

  ADD_COMPANY_DETAILS (state, company) {
    state.companyDetails = company
  },

  ADD_TITLE (state, title) {
    state.card.title = title
  },

  ADD_TAGS (state, tags) {
    if (state.card) {
      state.card.tags = tags
    }
  },

  UPDATE_TAGS (state, mode) {
    if (state.card) {
      let tags = state.card.tags || []
      if (mode.action === 'add') {
        Vue.set(mode.tag, 'selectedByCard', true)
        tags.push(mode.tag)
      } else if (mode.action === 'delete') {
        Vue.set(mode.tag, 'selectedByCard', false)
        let index = tags.findIndex(fil => fil.id === mode.tag.id)
        tags.splice(index, 1)
      }
    }
  },

  ADD_USERS (state, users) {
    if (state.card) {
      Vue.set(state.card, 'users', users)
    }
  },

  UPDATE_USERS (state, mode) {
    if (state.card) {
      let users = state.card.users || []
      if (mode.action === 'add') {
        users.push(mode.user)
      } else if (mode.action === 'update') {
        let index = users.findIndex(fil => fil.id === mode.user.id)
        if (index >= 0) {
          users.splice(index, 1, mode.user)
        } else {
          users.push(mode.user)
        }
      } else if (mode.action === 'delete') {
        let index = users.findIndex(fil => fil.id === mode.user.id)
        users.splice(index, 1)
        Vue.set(state.card, 'users', users)
      }
    }
  },

  ALL_CHECKITEM (state, { checkLists, checked }) {
    if (state.card) {
      var total = 0
      if (checked) {
        checkLists.forEach(list => {
          total = total + list.checkListItems.length
        })
      }
      state.card.checkedItems = total
    }
  },

  ADD_CHECKITEM (state) {
    if (state.card) {
      state.card.checkedItems = state.card.checkedItems + 1
    }
  },

  REMOVE_CHECKITEM (state) {
    if (state.card) {
      state.card.checkedItems = state.card.checkedItems - 1
    }
  },

  UPDATE_All_CHECKED_APROVED (state, { checkList }) {
    if (state.card && checkList[0].checked !== 'notapplicable') {
      checkList.forEach(list => {
        list.checked = 'checked'
        list.checkListItems.forEach(item => {
          if (!item.autoDocumentType && !item.chargeDocuments && item.triggersCount === 0 && item.checked !== 'checked' && !item.chargeDocuments) {
            item.checked = 'checked'
            state.card.checkedItems = state.card.checkedItems + 1
          } else {
            list.checked = 'unchecked'
          }
        })
      })
    } else {
      console.error('Não foi encontrado um cartão aberto')
    }
  },

  UPDATE_All_CHECKED (state, { checkLists, checked }) {
    if (state.card) {
      checkLists.forEach(list => {
        list.checkListItems.forEach(item => {
          item.checked = checked
        })
        list.checked = checked
      })
    } else {
      console.error('Não foi encontrado um cartão aberto')
    }
  },

  CHANGE_STATUS (state, status) {
    state.card.status = status
  },

  DESTROY_OPENED_CARD (state) {
    state.card = null
    state.companyDetails = null
  },

  UPDATE_DUE_STATE (state, { dueState, newDate }) {
    if (state.card) {
      state.card.dueState = dueState
      state.card.dueDate = newDate
    }
  },

  REMOVE_CARD_FROM_LISTS (state, { card, lists }) {
    var list = lists.find(f => f.id === card.listId)
    var cardIndex = list.cards.findIndex(index => index.id === card.id)
    if (cardIndex >= 0) {
      list.cards.splice(cardIndex, 1)
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
